import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175236ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk_add_produit" }
const _hoisted_2 = { class: "data-cards" }
const _hoisted_3 = { class: "card-icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Ajouter un produit")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "rk_produits_filtres data-cards"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Filtrer les produits par entreprise :", -1))
const _hoisted_7 = { class: "card-logo" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "info" }
const _hoisted_10 = {
  key: 0,
  class: "container"
}
const _hoisted_11 = { class: "card-logo" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "info" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]

import { onBeforeMount, onMounted } from 'vue'
import { ref } from "vue";
import axios from "axios";
import { toast } from 'vue3-toastify';
import { useAdminStore } from '../../store/piniaAdmin'
import { useLoginStore } from '../../store/piniaLogin'
import PlusCircleOutlineIcon from 'vue-material-design-icons/PlusCircleOutline.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'addProduitsView',
  setup(__props) {

const store = useAdminStore()


const storeLogin = useLoginStore()


// variable
const mainCategoriesSharp = ref([]);
const produitCats = ref([]);
const editProduitFormVisible = ref(false);
const editingProduct = ref();
const entreprises = ref([]);
const allServices = ref([]);
const mainCategories = ref([]);
const is_map_active = ref(false);
const produitFormVisible = ref(false);
const urlServer = ref(process.env.VUE_APP_SERVER_URL);
const userData = ref(JSON.parse(storeLogin.currentUser));
const contact = ref({ lat: userData.value.location.coordinates[1], long: userData.value.location.coordinates[0] });



function activeForm() {
    produitFormVisible.value = true;
    console.log(produitFormVisible.value);

}
function activeFormEdit(product) {
    editProduitFormVisible.value = true;
    editingProduct.value = product;


}
async function addProduit(values) {

    const form = new FormData();

    // form.append('name', values.form_presta.stepTwo.logo[0].name);
    // values.form_presta.stepTwo.logo.forEach((fileItem) => {
    //     form.append('logo', fileItem.file)
    // })
    values.images.forEach((fileItem) => {
        form.append('images', fileItem.file)
    })

    delete values.images;
    values.coordone = contact.value;

    form.append('datas', JSON.stringify(values));

    axios.post(process.env.VUE_APP_SERVER_URL + '/produits', form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(function (response) {
            console.log(response);

            toast.success("Votre produit viens d'être créé!");

        })
        .catch(function (error) {
            toast.error(error);
        });

    // // regler les horaires puis envoyer au serveur

}


async function editProduit() {

    const form = new FormData();



    form.append('datas', JSON.stringify(editingProduct.value));

    axios.put(process.env.VUE_APP_SERVER_URL + '/produits', form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(function () {
            editProduitFormVisible.value = false;

            toast.success("Votre produit viens d'être édité!");

        })
        .catch(function (error) {
            toast.error(error);
        });

    // // regler les horaires puis envoyer au serveur

}
async function getProdCats() {
    const categories = [];
    axios.get(process.env.VUE_APP_SERVER_URL + '/produits/cat')
        .then(function (response) {

            response.data.forEach((cat) => {
                categories.push({ label: cat.name, value: cat._id });
            })
            console.log(categories);

            produitCats.value = categories;
        })
        .catch(function () {
            // handle error
            produitCats.value = [];

        })
}

onMounted(async () => {
    getProdCats();

    is_map_active.value = true;
})

onBeforeMount(async () => {
    // axios.get(process.env.VUE_APP_SERVER_URL + '/categories')
    //     .then(function (response) {
    //         // handle success
    //         categories.value = response.data;
    //         console.log(categories.value);
    //     })
    //     .catch(function (error) {
    //         // handle error
    //         toast.error(error);
    //     })

    mainCategoriesSharp.value = await axios.get(process.env.VUE_APP_SERVER_URL + '/categories')
        .then(function (response) {
            // handle success
            mainCategories.value = response.data;


            store.setCategories(response.data)
            const categoriesSharp = [];
            mainCategories.value.forEach(element => {
                if (element.titre !== 'Bénévolat' && element.titre !== 'Prestation') {

                    categoriesSharp.push({ label: element.titre, value: element._id });
                }
            });
            return categoriesSharp;
        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })
    axios.get(process.env.VUE_APP_SERVER_URL + '/services')
        .then(function (response) {
            // handle success

            allServices.value = response.data;

        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })


    if (userData.value.entreprises.length > 0) {

        axios.get(process.env.VUE_APP_SERVER_URL + '/prestataires/my', {
            params: {
                myPrestas: userData.value.entreprises
            }
        })
            .then(function (response) {
                // handle success
                console.log(response);
                response.data.forEach((entreprise) => {
                    entreprises.value.push({ label: entreprise.nomEntreprise, value: entreprise._id, produits: entreprise.produits, logo: entreprise.logo })
                })


            })
            .catch(function (error) {
                // handle error
                toast.error(error);
            })
    }

})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["add_produits_form", { active: produitFormVisible.value }])
    }, [
      _createVNode(_component_FormKit, {
        type: "form",
        "submit-label": "Ajouter ce produit",
        onSubmit: addProduit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FormKit, {
            type: "text",
            label: "Titre du produit",
            name: "titre",
            "floating-label": true
          }),
          (entreprises.value.length > 1)
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 0,
                type: "autocomplete",
                name: "prestaId",
                label: "Entreprise qui produit :",
                options: entreprises.value
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (entreprises.value.length == 1)
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 1,
                type: "hidden",
                name: "prestaId",
                value: entreprises.value[0].value
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          _createVNode(_component_FormKit, {
            type: "textarea",
            "floating-label": true,
            "auto-height": "",
            name: "description",
            label: "Description du produit"
          }),
          _createVNode(_component_FormKit, {
            type: "number",
            "floating-label": true,
            step: "0.01",
            min: "0",
            label: "Prix",
            name: "prix"
          }),
          _createVNode(_component_FormKit, {
            type: "number",
            "floating-label": true,
            label: "Quantité en stock ",
            name: "quantite"
          }),
          _createVNode(_component_FormKit, {
            type: "autocomplete",
            multiple: "",
            name: "categories",
            label: "Catégorie",
            options: produitCats.value
          }, null, 8, ["options"]),
          _createVNode(_component_FormKit, {
            type: "file",
            name: "images",
            label: "Images du produit",
            multiple: "true"
          }),
          _createVNode(_component_FormKit, {
            type: "taglist",
            options: [''],
            name: "motsClefs",
            "allow-new-values": true,
            label: "Mots clefs (Validez le mot avec la touche 'entrée')",
            help: "Permet de retrouver votre produit facilement dans la marketplace"
          }),
          _createVNode(_component_FormKit, {
            type: "taglist",
            options: [''],
            name: "motsClefs",
            "allow-new-values": true,
            label: "Mots clefs (Validez le mot avec la touche 'entrée')",
            help: "Permet de retrouver votre produit facilement dans la marketplace"
          })
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card",
        onClick: activeForm
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PlusCircleOutlineIcon)
        ]),
        _hoisted_4
      ])
    ]),
    (entreprises.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entreprises.value, (entreprise, indexEntreprise) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card",
              router: "",
              key: indexEntreprise
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: urlServer.value + entreprise.logo,
                  alt: entreprise.label
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString(entreprise.label), 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entreprises.value, (entreprise, indexEntreprise) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "rk_produits",
        key: indexEntreprise
      }, [
        (entreprise.produits.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h3", null, "Produits de " + _toDisplayString(entreprise.label) + ":", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entreprise.produits, (produit, indexProduits) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card",
                  router: "",
                  key: indexProduits
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: urlServer.value + produit.images[0],
                      alt: produit.titre
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", null, _toDisplayString(produit.titre), 1),
                    _createElementVNode("p", null, "Qte : " + _toDisplayString(produit.quantite), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "rk_edit",
                    onClick: ($event: any) => (activeFormEdit(produit))
                  }, [
                    _createElementVNode("p", null, [
                      _createElementVNode("img", {
                        src: urlServer.value + '/uploads/kikekoi/icon-edit.svg',
                        alt: ""
                      }, null, 8, _hoisted_15),
                      _createTextVNode(" Editer ")
                    ])
                  ], 8, _hoisted_14)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass(["edit_produits_form", { active: editProduitFormVisible.value }])
    }, [
      (editProduitFormVisible.value)
        ? (_openBlock(), _createBlock(_component_FormKit, {
            key: 0,
            type: "form",
            modelValue: editingProduct.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editingProduct).value = $event)),
            "submit-label": "Editer ce produit",
            onSubmit: editProduit
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormKit, {
                type: "text",
                label: "Titre du produit",
                name: "titre",
                "floating-label": true
              }),
              _createVNode(_component_FormKit, {
                type: "textarea",
                "floating-label": true,
                "auto-height": "",
                name: "description",
                label: "Description du produit"
              }),
              _createElementVNode("div", null, [
                _createVNode(_component_FormKit, {
                  type: "number",
                  "floating-label": true,
                  step: "0.01",
                  min: "0",
                  label: "Prix",
                  name: "prix"
                }),
                _createVNode(_component_FormKit, {
                  type: "number",
                  "floating-label": true,
                  label: "Quantité en stock ",
                  name: "quantite"
                }),
                _createVNode(_component_FormKit, {
                  type: "autocomplete",
                  multiple: "",
                  name: "categories",
                  label: "Catégorie",
                  options: produitCats.value
                }, null, 8, ["options"]),
                _createVNode(_component_FormKit, {
                  type: "taglist",
                  options: editingProduct.value.motsClefs,
                  value: editingProduct.value.motsClefs,
                  name: "motsClefs",
                  "allow-new-values": true,
                  label: "Mots clefs (Validez le mot avec la touche 'entrée')",
                  help: "Permet de retrouver votre produit facilement dans la marketplace"
                }, null, 8, ["options", "value"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "rk_close_form",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (editProduitFormVisible.value = false))
      })
    ], 2)
  ]))
}
}

})